import { render, staticRenderFns } from "./HomePanel.vue?vue&type=template&id=5670a310&scoped=true"
import script from "./HomePanel.vue?vue&type=script&lang=js"
export * from "./HomePanel.vue?vue&type=script&lang=js"
import style0 from "./HomePanel.vue?vue&type=style&index=0&id=5670a310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670a310",
  null
  
)

export default component.exports